export const typeOfGroupOptions = [
  { value: 0, label: "Ongoing critique group." },
  { value: 1, label: "Pop up (short-term) critique group." },
  { value: 2, label: "Book Studies." },
  { value: 3, label: "Writing Challenges and Accountability Groups." },
  { value: 4, label: "Community/Discussion groups." },
  { value: 5, label: "Professional workshop." },
];